<template>
  <div>
    <video-player :options="videoOptions"/>
  </div>
</template>

<script>
import VideoPlayer from '@/components/mixin/VideoPlayer.vue'
import 'video.js/dist/video-js.min.css'
import 'videojs-font/css/videojs-icons.css'

export default {
  name: 'StreamViewerQs',
  components: { VideoPlayer },
  data () {
    return {
      contentsUrl: 'https://dlrma35v6z0lr.cloudfront.net/output/',
      videoOptions: {}
    }
  },
  created () {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'src')) {
      const tempVideoOption = {
        autoplay: false,
        controls: true,
        preload: 'auto',
        poster: this.contentsUrl + this.$route.query.poster,
        sources: [
          {
            src: this.contentsUrl + this.$route.query.src,
            type: 'application/x-mpegURL'
          }
        ]
      }
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'poster')) {
        tempVideoOption.poster = this.contentsUrl + this.$route.query.poster
      }
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'ratio')) {
        const tempRatio = this.$route.query.ratio.split(':')
        if (tempRatio.length === 2 && !isNaN(parseInt(tempRatio[0])) && !isNaN(parseInt(tempRatio[1]))) {
          tempVideoOption.miiaAspectRatio = parseInt(tempRatio[1]) / parseInt(tempRatio[0])
        }
      }
      this.videoOptions = tempVideoOption
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
